import type { PopupData } from 'webapp-types';

import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

export default class BlockPopupMedia extends PopupInnerContextComponent<PopupData.Block.Media> {
	get mediaUrl() {
		return this.popupData.mediaUrl;
	}

	get label() {
		return this.popupData.label;
	}
	<template><img src={{this.mediaUrl}} height="200" alt={{this.label}} /></template>
}
